// prettier-ignore
export let ABI = [{
    'anonymous': false,
    'inputs': [{'indexed': false, 'name': 'voteId', 'type': 'uint256'}, {
      'indexed': false,
      'name': 'eventText',
      'type': 'string'
    }],
    'name': 'VotingEvent',
    'type': 'event'
  }, {
    'anonymous': false,
    'inputs': [{'indexed': false, 'name': 'voteId', 'type': 'uint256'}, {
      'indexed': true,
      'name': 'addr',
      'type': 'address'
    }, {'indexed': true, 'name': 'votingId', 'type': 'uint256'}, {
      'indexed': false,
      'name': 'eventText',
      'type': 'string'
    }],
    'name': 'VoteEvent',
    'type': 'event'
  }, {
    'constant': false,
    'inputs': [],
    'name': 'register',
    'outputs': [],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{'name': '_percent', 'type': 'uint256'}],
    'name': 'initPercents',
    'outputs': [],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{'name': '_sb', 'type': 'string'}, {'name': '_dc', 'type': 'string'}, {'name': '_dl', 'type': 'uint256'}],
    'name': 'createVoting',
    'outputs': [{'name': '', 'type': 'bool'}],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'getPercentsForAccept',
    'outputs': [{'name': '', 'type': 'uint256'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{'name': 'id', 'type': 'uint256'}],
    'name': 'resolveVoting',
    'outputs': [{'name': '', 'type': 'bool'}],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'getVotingCounter',
    'outputs': [{'name': '', 'type': 'uint256'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{'name': '_voting', 'type': 'uint256'}],
    'name': 'getVoting',
    'outputs': [{'name': '_sb', 'type': 'string'}, {'name': '_dc', 'type': 'string'}, {
      'name': '_cr',
      'type': 'address'
    }, {'name': '_ct', 'type': 'uint256'}, {'name': '_dl', 'type': 'uint256'}, {
      'name': '_rt',
      'type': 'uint256'
    }, {'name': '_pd', 'type': 'bool'}, {'name': '_vs', 'type': 'int256'}, {'name': '_ra', 'type': 'address'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': false,
    'inputs': [{'name': 'votingId', 'type': 'uint256'}, {'name': 'verdict', 'type': 'bool'}],
    'name': 'vote',
    'outputs': [{'name': '', 'type': 'bool'}],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{'name': '_vote', 'type': 'uint256'}],
    'name': 'getVote',
    'outputs': [{'name': '_voter', 'type': 'address'}, {'name': '_voting', 'type': 'uint256'}, {
      'name': '_balance',
      'type': 'int256'
    }, {'name': '_time', 'type': 'uint256'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{'name': 'addr', 'type': 'address'}, {'name': 'votingId', 'type': 'uint256'}],
    'name': 'isVoted',
    'outputs': [{'name': '', 'type': 'bool'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'getVotes',
    'outputs': [{'name': '', 'type': 'uint256[]'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [{'name': 'votingId', 'type': 'uint256'}],
    'name': 'getVotingVotes',
    'outputs': [{'name': '', 'type': 'uint256[]'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }, {
    'constant': true,
    'inputs': [],
    'name': 'getVoteCounter',
    'outputs': [{'name': '', 'type': 'uint256'}],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
  }]
;
